// Detect wishlist request
(function () {
  const _originalFetch = window.fetch;

  window.fetch = function (...args) {
    const [url] = args;
    const promise = _originalFetch.apply(this, args);

    if (typeof url === "string" && url.includes("/move-all-wishlist")) {
      promise
        .then((response) => response.clone().json())
        .then((data) => {
          document.dispatchEvent(
            new CustomEvent("wishlist:moveAllComplete", { detail: data })
          );
        })
        .catch(() => {});
    }

    if (typeof url === "string" && url.includes("/save-wishlist")) {
      promise
        .then((response) => response.clone().json())
        .then((data) => {
          document.dispatchEvent(
            new CustomEvent("wishlist:addOrRemoveComplete", { detail: data })
          );
        })
        .catch(() => {});
    }

    if (typeof url === "string" && url.includes("/apps-wishlist")) {
      promise
        .then((response) => response.clone().json())
        .then((data) => {
          document.dispatchEvent(
            new CustomEvent("wishlist:searchDataLoaded", { detail: data })
          );
        })
        .catch(() => {});
    }

    return promise;
  };
})();

var cartOpPending = false;

function setCartButtonsDisabled(disabled) {
  document.querySelectorAll('#move_to_cart_all, button.wishlist-move-cart').forEach(function (b) {
    b.disabled = disabled;
    b.classList.toggle('disabled', disabled);
  });
}

document.addEventListener('click', function (e) {
  const activeButton = e.target.closest('#move_to_cart_all, button.wishlist-move-cart')
  if (activeButton) {
    cartOpPending = true;
    activeButton.disabled = true;
    activeButton.classList.toggle('disabled', true);
  }
});

new MutationObserver(function (mutations) {
  if (!cartOpPending) return;
  mutations.forEach(function (m) {
    m.addedNodes.forEach(function (node) {
      if (node.nodeType === 1 && node.classList.contains('wishlist-popup')) {
        cartOpPending = false;
        setCartButtonsDisabled(false);
      }
    });
  });
}).observe(document.body, { childList: true });

window.wishlistEngineCallback = function () {
  cartOpPending = false;
  setCartButtonsDisabled(false);
  setTimeout(function () {
    document.querySelectorAll('.wishlist-popup').forEach(function (p) { p.remove(); });
  }, 0);
  var cartDrawer = document.querySelector('cart-drawer');

  if (cartDrawer) cartDrawer.updateCartData();
};

var wPage = document.querySelector(".wishlist-page");
var bodyPage = document.querySelector("body");

if (wPage && window.location.pathname.includes("wishlist")) {
  bodyPage.style.overflow = "hidden";
  // Trigger the transition to full opacity
}
document.addEventListener("DOMContentLoaded", function () {
  var link = document.createElement("link");
  link.href = window.customAccountCSSUrl;
  link.rel = "stylesheet";
  link.type = "text/css";
  link.media = "all";
  document.head.appendChild(link);
    var intervalId = setInterval(function () {
      const wishlistPageContain = document.querySelector("#wishlist-page-contain"),
            wishlistRow = document.querySelector(".wishlist-row");
      if (wishlistPageContain && document.querySelector(".wishlist-page")) {
        //new: guard to prevent crash if there is no sidebar/row
        if (!wishlistRow) {
          return;
        }

        bodyPage.style.overflow = "auto";

        clearInterval(intervalId); // Stop the interval once the element is found and content is added
      }
    }, 1000); // Check every second (1000 ms)
  const isLoggedIn = !!document.getElementById(
    "wishlist-engine-customer-records",
  );
  if (!isLoggedIn) {
    document.body.classList.add("guest-customer");
  }
});

document.addEventListener("wishlist:page:loaded",function () {
  document.querySelector('.wishlist-page').classList.remove('loading');
});

document.addEventListener("wishlist:moveAllComplete", function (e) {
  const data = e.detail;
  let wishlistCount = data.data.wishlistTotalCount;
  const navWishlistCountEle = document.querySelector('.ar-nav__link .ar-wishlist-counter');
  if(navWishlistCountEle)
    navWishlistCountEle.innerHTML = wishlistCount;
});
document.addEventListener("wishlist:addOrRemoveComplete", function (e) {
  const data = e.detail;
  let wishlistCount = data.data.wishlistTotalCount;
  updateBulkActionVisibility(wishlistCount);
  const wishlistCountEle = document.querySelector('.ar-wishlist-shell .ar-section__counter'),
    navWishlistCountEle = document.querySelector('.ar-nav__link .ar-wishlist-counter');
  const wishlistCountText = wishlistCount > 1 ? window.wishlistStrings.totalItems : window.wishlistStrings.totalItem;
  if(wishlistCountEle){
    wishlistCountEle.innerHTML = wishlistCountText.replace('[count]', wishlistCount);
  }
  if(navWishlistCountEle){
    navWishlistCountEle.innerHTML = wishlistCount;
  }
  if(wishlistCount < 1) {
    const viewAction = document.querySelector('.ar-wishlist-overview .ar-section__action');

    if (viewAction) {
      viewAction.hidden = true;
      viewAction.classList.add('hidden');
    }
  } else {
    const viewAction = document.querySelector('.ar-wishlist-overview .ar-section__action');

    if (viewAction) {
      viewAction.hidden = false;
      viewAction.classList.remove('hidden');
    }
  }
});

document.addEventListener("wishlist:searchDataLoaded", function (e) {
  document.querySelectorAll('.wishlist-page.loading').forEach(function (element) {
    element.classList.remove('loading');
  });
  const data = e.detail;
  const wishlistCountEle = document.querySelector('.ar-wishlist-shell .ar-section__counter');
  const wishlistCountText = data.wishlistTotalCount > 1 ? window.wishlistStrings.totalItems : window.wishlistStrings.totalItem;
  if(wishlistCountEle){
    wishlistCountEle.innerHTML = wishlistCountText.replace('[count]', data.wishlistTotalCount);
  }

  const items = data.data || [];
  updateBulkActionVisibility(items.length);
  if(items.length < 1) {
    const viewAction = document.querySelector('.ar-wishlist-overview .ar-section__action');

    if (viewAction) {
      viewAction.hidden = true;
      viewAction.classList.add('hidden');
    }
  } else {
    const viewAction = document.querySelector('.ar-wishlist-overview .ar-section__action');

    if (viewAction) {
      viewAction.hidden = false;
      viewAction.classList.remove('hidden');
    }
  }

  if (!items.length) return;

  // Wait for wishlist-engine-app.js to render .wishlist-column elements into the DOM
  setTimeout(function () {
    appendWishlistProductMedia(items);

    items.forEach(function (item) {
      const savedVariant = item.variants && item.variants[item.shopify_variant_id];
      const isOOS = savedVariant
        && savedVariant.inventory_quantity <= 0
        && (savedVariant.inventory_policy || '').toUpperCase() !== 'CONTINUE';
      if (!isOOS) return;
      const col = document.getElementById('wishlist_page_' + item.shopify_id + '_' + item.shopify_variant_id);
      if (!col) return;
      col.classList.add('wishlist-column-oos');
      const colMeta = col.querySelector('.wihslist-meta');
      if (colMeta && !colMeta.querySelector('.restock-alert')) {
        colMeta.insertAdjacentHTML('beforeend',
          '<div class="restock-alert" data-product-id="' + item.shopify_id + '">'
          // + window.wishlistStrings.restockAlert
          + window.wishlistStrings.outOfStock
          + '</div>'
        );
      }
    });
  }, 300);
});

function escapeHtml(str) {
  return (str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

function updateBulkActionVisibility(count) {
  document
    .querySelectorAll('.ar-wishlist-shell:not(.ar-wishlist-overview) .bulk_action')
    .forEach(function (element) {
      element.style.display = count > 0 ? 'flex' : 'none';
    });
}

function formatWishlistPrice(price) {
  const moneyFormat = window.moneyWithCurrencyFormat;
  const amount = price / 100;
  const formatted = new Intl.NumberFormat(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
  return moneyFormat.replace(/\{\{.*?\}\}/, formatted);
}

function extractCodeAndSuffixFromUrl(url) {
  if (!url) {
      console.error('URL is undefined or null');
      return {
          code: '',
          suffix: ''
      };
  }
  let pattern = /-([A-Z]+)_(m?\d+|w\d+)_/i;
  let match = url.match(pattern);
  if (match && match[1]) {
      const code = match[1];
      const suffix = match[2];
      return {
          code,
          suffix
      };
  } else {
      pattern = /-([A-Z]+)_(\w+)\.jpg/i;
      match = url.match(pattern);
      if (match && match[1]) {
          const code = match[1];
          const suffix = match[2];
          return {
              code,
              suffix
          };
      } else {
          return {
              code: '',
              suffix: ''
          };
      }
  }
}

function findItemWithCodeAndSuffix(originalSize, code, number) {
  const pattern = new RegExp(`${code}_(m?${number})(\\D|$)`, 'i');
  return originalSize.find(item => {
      const src = item.src.toLowerCase();
      const isExcluded = src.includes(`_${number}0`) || src.includes("_a_") || src.includes("_a.") || src.includes("_m10");
      return pattern.test(src) && !isExcluded;
  })?.src;
}

function findFallback(images, number, exclusionSuffix) {
  return images.find(image => {
      const src = image.src.toLowerCase();

      if (src.includes("_a_") || src.includes("_a.")) return false;

      const afterFirstUnderscore = src.split("_")[1]?.split(".")[0];

      return afterFirstUnderscore === String(number);
  });
}


function getWishlistProductImages(images, colorOpt, seedUrl) {
  var primarySrc, secondarySrc;
  var isOneColor = !colorOpt || !colorOpt.values || colorOpt.values.length <= 1;

  if (!images.length) return { primarySrc: null, secondarySrc: null };

  if (isOneColor) {
      // Logic for products with only one color option
      function setImageFromRules(images) {
          let mainImage = images.find(image => image.src.toLowerCase().includes('_m1') && !image.src.toLowerCase().includes('_a_') && !image.src.toLowerCase().includes('_a.') && !image.src.toLowerCase().includes('_m10')) ||
              findFallback(images, 1, "10") ||
              findFallback(images, 2, "20");
          let hoverImage = images.find(image => image.src.toLowerCase().includes('_m2') && !image.src.toLowerCase().includes('_a_') && !image.src.toLowerCase().includes('_a.') && !image.src.toLowerCase().includes('_m20')) ||
              findFallback(images, 2, "20") ||
              findFallback(images, 3, "30");

          mainImage = mainImage ? mainImage.src : null;
          hoverImage = hoverImage ? hoverImage.src : null;

          primarySrc = mainImage || images[0]?.src || null;
          secondarySrc = hoverImage || images[1]?.src || null;
      }
      // Using the function to get the images
      setImageFromRules(images);
    } else {
      // Logic for products with multiple colors
      let attCheck = extractCodeAndSuffixFromUrl(seedUrl || images[0]?.src || '');
      if (attCheck.code && attCheck.suffix) {
          if (attCheck.suffix.toLowerCase() == "m1") {
              // Find hover image similar to the one-color logic
              let hoverImage = findItemWithCodeAndSuffix(images, attCheck.code, "m2") ||
                                findItemWithCodeAndSuffix(images, attCheck.code, "2");
              primarySrc = seedUrl || images[0]?.src || null;
              secondarySrc = hoverImage;
          } else if (attCheck.suffix.toLowerCase() != "m1") {
              // Find main and hover images similar to the one-color logic
              let mainImage = findItemWithCodeAndSuffix(images, attCheck.code, "m1") ||
                              findItemWithCodeAndSuffix(images, attCheck.code, "1");
              let hoverImage = findItemWithCodeAndSuffix(images, attCheck.code, "m2") ||
                                findItemWithCodeAndSuffix(images, attCheck.code, "2");

              // If not found, try with the next sequence number
              if (!mainImage) {
                  mainImage = findItemWithCodeAndSuffix(images, attCheck.code, "2");
                  hoverImage = findItemWithCodeAndSuffix(images, attCheck.code, "3");
              }

              primarySrc = mainImage || images[0]?.src || null;
              secondarySrc = hoverImage || images[1]?.src || null;
          }
      }
    }

    return { primarySrc, secondarySrc };
}

function appendWishlistProductMedia(items) {
  const handleMap = {};
  items.forEach(function (item) {
    if (!handleMap[item.handle]) handleMap[item.handle] = [];
    handleMap[item.handle].push(item);
  });

  Object.keys(handleMap).forEach(function (handle) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        const images = product.media || [];
        // product.options is [{name, position, values}, ...]
        var colorOpt = (product.options || []).find(function(o) {
          return (o.name || '').toLowerCase() === 'color' || (o.name || '').toLowerCase() === 'colour';
        });
        const colors = colorOpt ? colorOpt.values : [];

        const colorOptIdx = colorOpt ? (product.options || []).indexOf(colorOpt) : -1;
        const optKey = colorOptIdx >= 0 ? 'option' + (colorOptIdx + 1) : 'option1';

        const shopDomain = (window.Shopify && window.Shopify.shop) || window.location.hostname;

        handleMap[handle].forEach(function (item) {
          const col = document.getElementById('wishlist_page_' + item.shopify_id + '_' + item.shopify_variant_id);
          if (!col) return;

          const savedVariant = item.variants && item.variants[item.shopify_variant_id];
          const seedUrl = savedVariant.image_src || null;

          const { primarySrc, secondarySrc } = getWishlistProductImages(images, colorOpt, seedUrl);

          // Images
          if (primarySrc) {
            const colMedia = col.querySelector('.wishlist-top > a');
            if (colMedia) {
              const primaryImg = document.createElement('img');
              primaryImg.src = primarySrc;
              primaryImg.alt = product.title;
              primaryImg.loading = 'lazy';
              primaryImg.className = 'wishlist-media-primary';
              colMedia.appendChild(primaryImg);

              if (secondarySrc) {
                const secondaryImg = document.createElement('img');
                secondaryImg.src = secondarySrc;
                secondaryImg.alt = product.title;
                secondaryImg.loading = 'lazy';
                secondaryImg.className = 'wishlist-media-secondary';
                colMedia.appendChild(secondaryImg);
              }
            }
          }

          // Prices
          const colPrice = col.querySelector('.wishlist-price');
          const savedProduct = product.variants.find(variant => variant.id == item.shopify_variant_id);
          const rawPrice = savedProduct.price;
          if (!rawPrice) return;

          const rawCompare = savedProduct.compare_at_price;
          const onSale = rawCompare && parseFloat(rawCompare) > parseFloat(rawPrice);
          const formattedPrice   = formatWishlistPrice(rawPrice);
          const formattedCompare = rawCompare ? formatWishlistPrice(rawCompare) : '';
          const discountPct = onSale
            ? Math.round((parseFloat(rawCompare) - parseFloat(rawPrice)) / parseFloat(rawCompare) * 100)
            : 0;

          colPrice.classList.toggle('price--on-sale', !!onSale);
          colPrice.style.visibility = 'visible'
          colPrice.innerHTML = '<div class="price price__container">'
            + '<div class="price__regular">'
              + '<span class="price-item price-item--regular">' + formattedPrice + '</span>'
            + '</div>'
            + '<div class="price__sale">'
              + (onSale ? '<span><s class="price-item price-item--regular">' + formattedCompare + '</s></span>' : '')
              + (onSale ? '<span class="price-item price-item--percent"> | ' + discountPct + '% off </span>' : '')
              + '<span class="price-item price-item--sale price-item--last">' + formattedPrice + '</span>'
            + '</div>'
            + '</div>';
          });
      })
      .catch(function () {
        handleMap[handle].forEach(function (item) {
          const col = document.getElementById('wishlist_page_' + item.shopify_id + '_' + item.shopify_variant_id);
          if (!col) return;
          col.classList.add('wishlist-column-unavailable');
          col.querySelector('input[type="checkbox"][name="wishlist_item_checkbox"]').remove();
          const colMeta = col.querySelector('.wihslist-meta');
          if (colMeta && !colMeta.querySelector('.unavailable')) {
            colMeta.insertAdjacentHTML('beforeend',
              '<div class="unavailable" data-product-id="' + item.shopify_id + '">'
              + window.variantStrings.unavailable
              + '</div>'
            );
          }
        });
      });
  });
}
